import React from 'react';
import './Home.css';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import heroBg from '../Assets/images/hero-bg.jpg';
import logo from '../Assets/images/logo.jpg';
import jetCar from '../Assets/images/jet-car.png';
import testimonialUser from '../Assets/images/testimonial-user.jpeg'

const Home = () => {
    return (
        <div className="home-container">

            <header className="navbar">
                <div className="top-bar">
                    <span>📍 Juffair - bahrain</span>
                    <span>📧 support@limoxyworld.com</span>
                    <span>⏰ 24/7 Available</span>
                </div>
                <div className="main-nav">
                    <div className="logo-container">
                        <img src={logo} alt="Limoxy Logo" className="logo-image" />
                        <span className="logo-text">LIMOXY</span>
                    </div>
                    <nav>
                        <Link to="/">Home</Link>
                        <Link to="/about">About Us</Link>
                        <Link to="/services">Our Services</Link>
                        <Link to="/contact">Contact</Link>
                        <Link to="/partner">Partner</Link>
                    </nav>
                    <Link to="/Bookride">
                        <button className="book-btn">Book Your Ride</button>
                    </Link>
                </div>
            </header>


            <section className="hero" style={{ backgroundImage: `url(${heroBg})` }}>
                <div className="overlay">
                    <h1><strong>A premium, chauffeur-based experience – from arrival to farewell.</strong></h1>
                    <p className="over">Global ground transport for the world’s top tier</p>
                    <button className="get-started-btn">Let's Get Started <FaArrowRight /></button>

                    <div className="services-buttons">
                        <div className="hero-form-section">
                            <div className="service-buttons">
                                <Link to="/Airport" className="service-btn">Airport Transfer</Link>
                                <Link to="/Chauffeur" className="service-btn">Full Day Chauffeur</Link>
                                <Link to="/Cityrides" className="service-btn">City To City Rides</Link>
                                <Link to="/Rental" className="service-btn">Car Rental</Link>
                                <Link to="/Greet" className="service-btn">Meet & Greet</Link>

                            </div>
                        </div>
                        <div>
                            <form className="quick-book-form" onSubmit={(e) => {
                                e.preventDefault();

                                alert('Redirecting to detailed booking...');
                            }}>
                                <input type="date" placeholder="Pick Up Date" required />
                                <input type="time" placeholder="Pick Up Time"  required />
                                <input type="text" placeholder="Pick Up Location" required />
                                <input type="text" placeholder="Days" required />
                                <button type="submit" className="book-now-btn">Book Now</button>
                            </form></div>
                    </div>
                </div>
            </section>


            <section className="about-1">
                <div className="about-text">
                    <h2>A Global Network. A Singular Standard.</h2>
                    <p>
                        At Limoxy World, every journey is a signature experience — defined by excellence, discretion, and flawless coordination.
                        Our international network of hand-selected chauffeurs ensures consistency and sophistication no matter where your travels take you.
                        We don’t follow standards. We set them. That truly is the Limoxy World difference.
                    </p>
                </div>
                <div className="about-image">
                    <img src={jetCar} alt="Jet with luxury car" />
                </div>
            </section>

            <section className="stats">
                <div>100%<br />Corporate Management</div>
                <div>24/7<br />Customer Support</div>
                <div>8+<br />Years</div>
                <div>99%<br />Client Retention</div>
                <div>45000+<br />Worldwide Location</div>
            </section>


            <section className="testimonials">
                <div>
                    <h4>Manoof muhammad</h4>
                    <p>CEO – Marketing</p>
                    <q>Luxury isn't a feature—it's our foundation</q>
                </div>
                <div>
                    <h4>Shafeer Arik</h4>
                    <p>CEO – Operations</p>
                    <q>We’re in the business of trust and first-class experiences</q>
                </div>
                <div>
                    <h4>Afsal Abdulrazaq</h4>
                    <p>CEO – Finance</p>
                    <q>My vision is to provide more than a ride—it’s to create a trusted, elevated travel experience.</q>
                </div>
            </section>


            <section className="what-when-how">
                <div className="box">
                    <h3>WHAT</h3>
                    <p className="highlight">Premium chauffeur-driven transport services for individuals and businesses.</p>
                    <ul>
                        <li>Available for airport transfers, corporate travel, events, and leisure trips.</li>
                        <li>Luxurious vehicles tailored for comfort, style, and convenience.</li>
                    </ul>
                </div>
                <div className="box">
                    <h3>When</h3>
                    <p className="highlight">Available 24/7 to meet your schedule and travel needs.</p>
                    <ul>
                        <li>Ideal for last-minute bookings, pre-planned events, or regular commutes.</li>
                        <li>Flexible and punctual service designed around your requirements.</li>
                    </ul>
                </div>
                <div className="box">
                    <h3>HOW</h3>
                    <p className="highlight">Our attention to detail defines how we operate from vehicle presentation to client interaction, every element reflects excellence.</p>
                    <ul>
                        <li>White-glove service from a globally certified chauffeur team.</li>
                        <li>Impeccable standards enforced across borders, ensuring consistency wherever you ride.</li>
                    </ul>
                </div>
            </section>


            <section className="services-hero">
                <h2>Chauffeur services redefined for modern business and luxury travel.</h2>
                <p>Available worldwide — driven by service, powered by trust.</p>
            </section>


            <section className="our-services">
                <h2>Our Services</h2>
                <p className="subheading">Explore Our Services Tailored To You</p>
                <div className="service-1">
                    {[
                        {
                            title: "Airport transfer",
                            desc: "As a global premium chauffeur service, we deliver airport transfers that combine precision, luxury, and peace of mind.",
                            img: require('../Assets/images/airport.jpg')
                        },
                        {
                            title: "Chauffeur service",
                            desc: "Experience the highest level of comfort and class with our premium chauffeur service.",
                            img: require('../Assets/images/chauffeur.jpg')
                        },
                        {
                            title: "City to city rides",
                            desc: "New level of intercity travel with chauffeur rides—comfort, privacy, and punctuality.",
                            img: require('../Assets/images/city.webp')
                        },
                        {
                            title: "Car rental",
                            desc: "We offer premium car rentals with or without a chauffeur—perfect for business or leisure.",
                            img: require('../Assets/images/car.jpg')
                        },
                        {
                            title: "Meet & greet service",
                            desc: "At major airports worldwide, our Meet & Greet service ensures timely assistance and smooth start or end.",
                            img: require('../Assets/images/greet.jpg')
                        }
                    ].map((service, index) => (
                        <div className="service-card" key={index}>
                            <img src={service.img} alt={service.title} />
                            <h3>{service.title}</h3>
                            <p>{service.desc}</p>
                        </div>
                    ))}
                </div>
            </section>


            <section className="why-limoxy">
                <h2>Why Limoxy World</h2>
                <div className="why-items">
                    {[
                        { title: "Ground expertise", icon: "🌍", desc: "Largest networks of trusted chauffeurs worldwide, ensuring a seamless experience." },
                        { title: "Personalized booking support", icon: "📅", desc: "Count on professionals who value privacy, punctuality, and presentation." },
                        { title: "Our highest priority", icon: "🛡", desc: "Safety and elite chauffeurs with elite standards and maintained vehicles." },
                        { title: "Dedicated customer support", icon: "💬", desc: "Available 24/7 for support, urgent changes, or personal requests." },
                        { title: "Technology", icon: "⚙", desc: "Our tech ensures your trip runs exactly as planned—no delays or guesswork." },
                    ].map((item, index) => (
                        <div className="why-card" key={index}>
                            <div className="why-icon">{item.icon}</div>
                            <h3>{item.title}</h3>
                            <p>{item.desc}</p>
                        </div>
                    ))}
                </div>
            </section>


            <section className="client-testimonial">
                <h2>Hear From Our Satisfied Clients Have To Say</h2>
                <div className="testimonial-quote">
                    <hr />
                    <span className="quote-icon">"</span>
                    <hr />
                </div>
                <p className="testimonial-text">
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                    when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                </p>
                <p className="testimonial-author">Mariya</p>
                <p className="testimonial-role">Lorem Ipsum, Lorem Ipsum</p>
                <img className="testimonial-img" src={require('../Assets/images/testimonial-user.jpeg')} alt="Mariya" />
            </section>


            <section className="cta-banner">
                <p>Get Started Limoxy World Today By Contacting Us Using Your Preferred Method</p>
                <button
                    className="connect-btn"
                    onClick={() =>
                        window.open('https://wa.me/917025746949', '_blank')
                    }
                >
                    Connect With Us
                </button>
            </section>


            <footer className="footer">
                <div className="footer-left">
                    <div className="footer-logo">
                        <img src={logo} alt="Limoxy Logo" />
                        <h3 className='footername'>LIMOXY</h3>
                    </div>
                </div>

                <div className="footer-links">

                    <div className="footer-links">
                        <h4>LINKS</h4>
                        <Link to="/">Home</Link>
                        <Link to="/about">About</Link>
                        <Link to="/services">Services</Link>
                        <Link to="/contact">Contact</Link>
                    </div>
                </div>



                <div className="footer-contact">
                    <h4>CONTACT INFO</h4>
                    <p><strong>Address:</strong> Juffair - bahrain</p>
                    <p><strong>Email:</strong> support@limoxyworld.com</p>
                   
                </div>
            </footer>
        </div>

    );
};

export default Home;